import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/probability-of-profit-calculator',
  component: () => import('../../routes/ProbabilityOfProfitCalculator.svelte'),
  card: {
    id: 'probability-of-profit-calculator',
    title: 'Probability of Profit Calculator',
    description: 'Calculate the likelihood of achieving at least one profitable trade over N trades using the binomial distribution.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/probability-of-profit-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Probability of Profit Calculator – Trading Win Rate & POP',
    description: 'Free probability of profit calculator. Calculate the likelihood of at least one winning trade over N trades using the binomial distribution. Includes breakeven win rate and expected value analysis.',
  },
};

export default meta;